import React, { useEffect,useState } from 'react';
import { useNavigate } from "react-router";
import CustomModal from '../CustomModal/CustomModal';
import UtilityService from '../../services/UtillityServices/UtilityService';
import imgCard from '../../assets/img/orange-classroom.jpg';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import DOMPurify from 'dompurify';
import { TIPO_CORSO } from '../../model/tipoCorso';

const CorsoCard = ({ courseData }) => {
  console.log(courseData);
  const navigate = useNavigate(); 
  const {REACT_APP_REST_DOMAIN} = process.env;
  const imageUrl = courseData.immagine_corso || imgCard;
  const imgSrc = imageUrl.startsWith(REACT_APP_REST_DOMAIN) ? 'http://' + imageUrl : imageUrl;
  const [showModalDetailsCorso, setShowModalDetailsCorso] = useState(false);
  const userLoggedIn = useSelector(state => state?.user?.userData);

  useEffect(() => {//NEW
    if (courseData.stato_pagamento === 'Non_pagato' && courseData.scontoAttivo && courseData.is_bonifico_corsista == "0") {
      handleIscriviti();
    }
  }, [courseData]);

  const handleIscriviti = () => {
    if (courseData.pagato || courseData.stato_pagamento === 'Parzialmente_pagato') {//NEW
      const formatCourseData = {
        ...courseData,
        corso: courseData,
        stato_pagamento: courseData.stato_pagamento
      }
      if(courseData.cond1 == 0 || courseData.cond2 == 0 || courseData.cond3 == 0){
        navigate(`/corso/${courseData.id_classe}`, { state: { courseData } });
      }
      else{
        if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
          navigate(`/area-personale/corso`, { state: { classe: formatCourseData } });
        } else {
          navigate(`/area-personale/classe`, { state: { classe: formatCourseData } });
        }
      }
    } else {
      navigate(`/corso/${courseData.id_classe}`, { state: { courseData } });
    }
  };
  
  const handleDetailsCorso = () => {
    //setShowModalDetailsCorso(true)
    navigate(`/corso/${courseData.id_classe}`, { state: { courseData } });
  };

  const handleIscriviUtenteCorso = () => {//NEW
    const formatCourseData = {
      ...courseData,
      corso: courseData
    }
    if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      navigate('/gestione-utenti', { state: { formatCourseData } });
    } else {
      navigate('/gestione-utenti', { state: { formatCourseData } });
    }
  };

  const handleCloseModal = () => {
    setShowModalDetailsCorso(false)
  };

  const renderHtml = (content) => {
    return { __html: DOMPurify.sanitize(content) };
  };

  const renderText = (name, label, mtTop = true) => (
    name && (
      <>
        <b className={`fs-6 ${mtTop ? 'mt-3' : ''} mb-1 d-block`}>{label || ''}</b>
        <div dangerouslySetInnerHTML={renderHtml(name)} />
      </>
  )
  )

  const printModalCorsoDetails = () => (
    <div className="text-dark">
      {renderText(courseData?.note, 'Descrizione', false)}
      {courseData?.certificazione && (<span><b className='fs-6 mt-3 mb-1 d-block'>Certificazione</b>{courseData?.certificazione?.descrizione}</span>)}
      {courseData?.modalita_erogazione && (<span><b className='fs-6 mt-3 mb-1 d-block'>Modalità erogazione</b>{UtilityService.getModalitaErogazione(courseData.modalita_erogazione)}</span>)}
      {courseData.docenti && courseData.docenti?.length > 0 && (<span><b className='fs-6 mt-3 mb-1 d-block'>Docenti</b>{courseData.docenti?.map(docente => `${docente.nome} ${docente.cognome}`).join(', ')}</span>)}
      {courseData?.sede?.descrizione && (<span><b className='fs-6 mt-3 mb-1 d-block'>Sede</b>{courseData?.sede?.descrizione}</span>)}
      {renderText(courseData?.fruizione_corso, 'Fruizione')}
      {courseData?.data_inizio_classe && (<span><b className='fs-6 mt-3 mb-1 d-block'>Data inizio</b>{UtilityService.formatDate(courseData.data_inizio_classe)}</span>)}
      {courseData?.data_fine_classe && (<span><b className='fs-6 mt-3 mb-1 d-block'>Data fine</b>{UtilityService.formatDate(courseData.data_fine_classe)}</span>)}
      {renderText(courseData?.istruzioni_svolgimento_corso, 'Istruzioni svolgimento corso')}
      {renderText(courseData?.esame, 'Esame')} 
      {renderText(courseData?.istruzioni_svolgimento_esame, 'Istruzioni svolgimento esame')} 
      {renderText(courseData?.contratto_formativo, 'Contratto formativo')} 
      {renderText(courseData?.obiettivo, 'Obiettivo')} 
      {renderText(courseData?.argomento, 'Argomento')} 
      {renderText(courseData?.strumento_supporto, 'Strumenti di supporto')} 
      {renderText(courseData?.struttura, 'Struttura')} 
      {renderText(courseData?.frequenza, 'Frequenza')} 
      {courseData?.titolo_studio_min && (<span><b className='fs-6 mt-3 mb-1 d-block'>Titolo di studio minimo</b>{courseData.titolo_studio_min}</span>)}
      {courseData?.perc_assenze_max && (<span><b className='fs-6 mt-3 mb-1 d-block'>Massimo percentuale assenze</b>{Math.round(courseData.perc_assenze_max)}%</span>)}
      {courseData?.durata && (<span><b className='fs-6 mt-3 mb-1 d-block'>Durata</b>{courseData.durata} {courseData.durata == "1" ? "ora" : "ore"}</span>)}
    </div>
  )

  const truncateDescription = (text, maxLength = 200) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  const renderModalitaIcons = (modalita) => {
    if (!modalita) {
      return <i className="bi bi-question-circle me-2" title="Modalità erogazione non selezionata"></i>;
    }
    
    const iconMap = {
      'Presenza': <i className="bi bi-building me-2" title="In presenza"></i>,
      'Telematica_Sincrona': <i className="bi bi-camera-video me-2" title="Telematica sincrona"></i>,
      'Telematica_Asincrona': <i className="bi bi-play-circle me-2" title="Telematica asincrona"></i>,
      'Mista_Presenza/Telematica': (
        <>
          <i className="bi bi-building me-2" title="In presenza"></i>
          <i className="bi bi-camera-video me-2" title="Telematica"></i>
        </>
      ),
      'Telematica_Mista': (
        <>
          <i className="bi bi-camera-video me-2" title="Sincrona"></i>
          <i className="bi bi-play-circle me-2" title="Asincrona"></i>
        </>
      )
    };

    return iconMap[modalita] || <i className="bi bi-question-circle me-2" title="Modalità erogazione non selezionata"></i>;
  };

  const prezzo = parseFloat(courseData?.prezzo) || 0;
  const sconto = parseFloat(courseData?.sconto) || 0;

  const renderButton = () => {
    const isTelematicaAsincrona = courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA;

    if (courseData.pagato || courseData.stato_pagamento === 'Parzialmente_pagato') {//NEW
      return (
        <button 
          className='btn btn-primary me-1' 
          onClick={handleIscriviti}
        >
          {isTelematicaAsincrona ? (
            <>
              <i className="bi bi-play-circle me-2"></i>Accedi al Corso
            </>
          ) : (
            <>
              <i className="bi bi-door-open me-2"></i>Accedi alla Classe
            </>
          )}
        </button>
      );
    }

    if (courseData.stato_pagamento === 'Non_pagato' && courseData.is_bonifico_corsista == "1") {
      return (
        <button className='btn btn-primary me-1' disabled>
          Verifica bonifico in corso...
        </button>
      );
    }
    
    if (courseData.stato_pagamento === 'Non_pagato' && courseData.scontoAttivo) {
      return (
        <button className='btn btn-primary me-1' onClick={handleIscriviti}>
          Completa Acquisto
        </button>
      );
    }

    return (
      <button className='btn btn-primary me-1' onClick={handleIscriviti}>
        {(userLoggedIn?.role === ROLES.CORSISTA || !userLoggedIn) ? "Iscriviti" : "Visualizza"}
      </button>
    );
  };

  const renderRightButton = () => {//NEW
    if (userLoggedIn?.role === ROLES.PARTNER) {
      return(
        <button className='btn btn-primary me-1' onClick={handleIscriviUtenteCorso}>
          Iscrivi utente
        </button>
      );
    }

    if((courseData.cond1 > 0 || courseData.cond2 > 0 || courseData.cond3 > 0) && courseData.stato_pagamento === 'Pagato'){//NEW
      return (
        <button className='btn btn-secondary me-1' onClick={handleDetailsCorso}>
          Dettagli
        </button>
      );
    }
  }

  return (
    <>
    
    <div className="col-md-6 col-xl-3 my-2">
      <div className="card shadow h-100">
        <img className="card-img-top" src={imgSrc} alt="Corso card" />
        <span className="badge bg-light text-dark fs-6 position-absolute top-0 start-0 m-2 border">
          {courseData.pagato ? (
            "Acquistato"
          ) : courseData.scontoAttivo ? (
            <>
              <span className="text-decoration-line-through me-2">{prezzo.toFixed(2)}€</span>
              <span className="text-success">{(prezzo - sconto).toFixed(2)}€</span>
            </>
          ) : (
            `${prezzo.toFixed(2)}€`
          )}
          <i className="bi bi-bag-check ms-2"></i>
        </span>
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">{courseData.denominazione}</h5>
          <p className="card-text">{truncateDescription(courseData.descrizione)}</p>
          <div className="mt-auto py-3">
            {renderButton()}
            {renderRightButton()}
          </div>
          <div className="small">
            <div className="d-flex justify-content-between my-2">
              {
               courseData.modalita_erogazione === "Telematica_Asincrona" ? ( 
              <>
              <span className="text-muted">
                <i className="bi bi-clock me-1"></i> {courseData.durata} {courseData.durata == "1" ? "ora" : "ore"}
              </span>
              </> 
              
              ) : (
                <>
                  <span className="text-muted">
                    <i className="bi bi-calendar-event me-1"></i> {UtilityService.formatDate(courseData.data_inizio_classe)}
                  </span>
                  <span className="text-muted">
                    <i className="bi bi-calendar-event me-1"></i> {UtilityService.formatDate(courseData.data_fine_classe)}
                  </span>
                </>
              )
              }       
            </div>
          </div>
          <div className="small">
            <div className="d-flex align-items-center justify-content-between my-2">
              <div>
              {renderModalitaIcons(courseData?.modalita_erogazione)}
              <span className="text-muted">
                {UtilityService.getModalitaErogazione(courseData?.modalita_erogazione) === 'Nessuna opzione' ? 'Modalità erogazione non selezionata' : UtilityService.getModalitaErogazione(courseData?.modalita_erogazione)}
              </span>
              </div>
              <div>
          {
            courseData.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
              <div>
                <span className="text-muted">
              <i className="bi bi-people me-1"></i> {courseData.numero_iscritti} / {courseData.numero_massimo_corsisti}
            </span>
              </div>
            )
          }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomModal
        show={showModalDetailsCorso}
        headerText={`${courseData?.denominazione}`}
        onHide={handleCloseModal}
        size={"md"}
        scrollable={true}
        body={printModalCorsoDetails()}
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />
    </>
  );
}

export default CorsoCard;
